export const APPLICATION_NAME = 'Urban Mobility CMS';
export const BASE_URL: string = import.meta.env.VITE_APP_BASE_URL || 'http://localhost:8080';
export const TOKEN_KEY: string = import.meta.env.VITE_APP_TOKEN_KEY || 'umc_access_token';
export const USER_KEY = 'umc_user_info';

export const httpVerbs = {
  POST: 'POST',
  PATCH: 'PATCH',
  GET: 'GET',
  PUT: 'PUT',
  DELETE: 'DELETE',
};
